var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.bemBlock }, [
    _c(
      "div",
      {
        directives: [{ name: "dragscroll", rawName: "v-dragscroll" }],
        ref: "products",
        class: _vm.bemElement("products")
      },
      [
        _c(
          "div",
          {
            ref: "main",
            class: _vm.bemElement("main"),
            style: _vm.cssCustomProps
          },
          _vm._l(_vm.uiComplementProducts, function(complement, i) {
            return _c("TheProductCustomizerComplementVisualizer", {
              key: i,
              attrs: { complement: complement, "edit-mode": _vm.editMode },
              on: {
                "complement-visualizer:show": _vm.scrollToRight,
                "complement-visualizer:remove": function($event) {
                  return _vm.handleComplementRemove($event, complement, i)
                }
              }
            })
          }),
          1
        )
      ]
    ),
    _vm._v(" "),
    _vm.editMode || _vm.uiComplementProducts.length
      ? _c(
          "button",
          { class: _vm.bemElement("edit"), on: { click: _vm.toggleEditMode } },
          [_vm._v("\n    " + _vm._s(_vm.editButtonText) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }